import { render, staticRenderFns } from "./TileControl.vue?vue&type=template&id=6b747af1"
import script from "./TileControl.vue?vue&type=script&lang=js"
export * from "./TileControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports